const swatchHover = (element = document) => {
    const productOptionsFormWrapper = element.querySelector('.product.product-options-form-wrapper');
    if (!productOptionsFormWrapper) {
        return;
    }
    const productSwatches = productOptionsFormWrapper.querySelector('.product-swatches');
    if (productSwatches) {
        const selectedMaterial = element.querySelector('.selected-material');
        if (selectedMaterial ) {
            
            const originalMaterial = selectedMaterial.innerHTML;
            const circleSwatches = productSwatches.querySelectorAll('.color-circle');
            
            circleSwatches.forEach((circleSwatch) => {
                circleSwatch.addEventListener('mouseover', (event) => {
                    if (event.target.dataset.material != null) {
                        let currentMaterial = event.target.dataset.material.replace('-', ' ');
                        selectedMaterial.innerHTML = `${currentMaterial}`;
                    }
                });
                
                productSwatches.addEventListener('mouseleave', () => {
                    selectedMaterial.innerHTML = originalMaterial;
                });
            });
        }
    }
};

function swatchSecondVariantLink() {
    const colorSwatches = document.querySelectorAll('.product-options-form-wrapper .color-circle');
    const secondVariantOptions = document.querySelectorAll('.second-variant-options .second-variant-options__option');

    if (secondVariantOptions.length > 0 && colorSwatches.length > 0) {

        // Loop through secondVariantOptions to find the index of the element that has the class active
        secondVariantOptions.forEach((secondVariantOption, optionIndex) => {
            if (secondVariantOption.classList.contains('active')) {

                // Get the data-href attribute from the colorSwatches element with the same index
                colorSwatches.forEach(swatch => {
                    const swatchLink = swatch.getAttribute(`data-href-${optionIndex}`);
                    const swatchAvailable = swatch.getAttribute(`data-available-${optionIndex}`);

                    // Set the href attribute of the swatch element to the selected variant link
                    if (swatchLink != null) {
                        swatch.href = swatchLink;

                        // Disable the swatch if it is already selected
                        if (swatch.classList.contains('selected-swatch')) {
                            swatch.addEventListener('click', (e) => {
                                e.preventDefault();
                            });
                        }
                    }

                    // Enable the swatch if the second variant is available
                    if (swatchAvailable == 'true') {
                        swatch.classList.remove('disabled');
                    }

                    // Only do this to the swatches if at least one of the swatches contains the attribute
                    if (secondVariantOptions.length > 0 && swatch.getAttribute('data-href-0') == null) {
                        swatch.classList.remove('disabled');
                    }
                });
            }
        });
    }
}

swatchHover()
swatchSecondVariantLink();

// Run again when content is reloaded 
window.addEventListener('productFormRendered', () => {
swatchHover();
swatchSecondVariantLink();
})

export { swatchHover, swatchSecondVariantLink };
